import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import playerReducer from './slices/playerSlice';
import matchReducer from './slices/matchSlice';
import tournamentReducer from './slices/tournamentSlice';
import { connectApi } from '../services/connectApi';
import { marketplaceApi } from '../services/marketplaceApi';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    players: playerReducer,
    matches: matchReducer,
    tournaments: tournamentReducer,
    [connectApi.reducerPath]: connectApi.reducer,
    [marketplaceApi.reducerPath]: marketplaceApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(connectApi.middleware)
      .concat(marketplaceApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;